import { LocalStorage } from 'libs/common';
import projectInfo from '../package.json';
import Service from './classes/Service';
import services from './services';
import './func_common';
import './func_calls';

const config = { ...window.config };
// change urls for development env
const test = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test' || process.env.REACT_APP_DEV === '1';
if (test) {
  console.log('env: test');

  if (!!config?.network && window.location.href.indexOf('localhost') !== -1) {
    localStorage.debug = '';
    config.network.timeout = 5000;
    config.localver = true;
    config.use_lang = true;
    config.use_common_counters = true;
    // config.crm_url = 'https://crm.stockmann.stage.caps.cursusts.ru';
    // config.exhibition = true;
    // config.testEvents = 'unrecognized'; // greylist unrecognized

    // svx (real object)
    // config.network.api_url = 'https://svx-caps-mnemo.ar.int/api';
    // config.network.socket_url = 'https://svx-caps-mnemo.ar.int';
    // config.network.images_url = 'https://svx-caps-mnemo.ar.int/photos/';

    // stage
    config.network.api_url = 'https://mnemo.stockmann.stage.caps.cursusts.ru/api';
    config.network.socket_url = 'https://mnemo.stockmann.stage.caps.cursusts.ru';
    config.network.images_url = 'https://mnemo.stockmann.stage.caps.cursusts.ru/photos/';

    // some prod
    // config.network.api_url = 'http://192.168.55.101:8080/api';
    // config.network.socket_url = 'http://192.168.55.101:8080';
    // config.network.images_url = 'http://192.168.55.101:8080/photos/';

    // tumen
    // config.network.api_url = 'https://mnemo.tumen.stage.caps.cursusts.ru/api';
    // config.network.socket_url = 'https://mnemo.tumen.stage.caps.cursusts.ru';
    // config.network.images_url = 'https://mnemo.tumen.stage.caps.cursusts.ru/photos/';

    // prod
    // config.network.api_url = 'http://10.100.62.201:8080/api';
    // config.network.socket_url = 'http://10.100.62.201:8080';
    // config.network.images_url = 'http://10.100.62.201:8080/photos/';

    // config.network.api_url = 'http://10.101.181.2:8080/api';
    // config.network.socket_url = 'http://10.101.181.2:8080';
    // config.network.images_url = 'http://10.101.181.2:8080/photos/';

    // config.network.api_url = 'http://10.28.0.2:8080/api';
    // config.network.socket_url = 'http://10.28.0.2:8080';
    // config.network.images_url = 'http://10.28.0.2:8080/photos/';

    // exibition
    if (config.exhibition) {
      config.network.api_url = 'https://mnemo.demo.stage.caps.cursusts.ru/api';
      config.network.socket_url = 'https://mnemo.demo.stage.caps.cursusts.ru';
      config.network.images_url = 'https://mnemo.demo.stage.caps.cursusts.ru/photos/';
    }
  }
}

// global services
window.config = config;
window.dict = {};
// window.dict = {
//   reasonofpass: [
//     { id: 1, dictionary_id: 'reasonofpass', name: 'Неисправность оборудования', value: '1' },
//     { id: 1, dictionary_id: 'reasonofpass', name: 'Неисправность оборудования Неисправность оборудования', value: '2' },
//   ],
// };
window.service = new Service();
for (let key in services) {
  window.service.add(key, services[key]);
}

/**
 * set data from url
 */
const setTokenFromUrl = () => {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');
  params.delete('token');
  window.rack_id = params.get('rack_id');
  window.zone_id = params.get('zone_id');
  if (token) {
    const storage = new LocalStorage('api');
    storage.setItem('token', token);
    const newParams = params.toString();
    let path = location.pathname;
    if (newParams) {
      path += '?' + newParams;
    }
    window.history.replaceState(null, '', path);
  }
};
setTokenFromUrl();

console.log('version: ' + projectInfo.version);
console.log('API url: ' + config.network?.api_url);

export { config };
